export default "__VITE_ASSET__D2yqZ6eg__"